export const accueilNavBar = {
  label: 'Accueil',
  labelDisable: true,
  children: [
    {
      name: "Page d'accueil",
      to: '/',
      exact: true,
      active: true
    },
    {
      name: "Nous contacter",
      to: '/contact',
      exact: true,
      active: true
    },
  ]
};

export const dpsNavBar = {
  label: 'Postes de Secours',
  labelDisable: true,
  children: [
    {
      name: "Qu'est-ce qu'un poste de secours ?",
      to: '/dpsInfo',
      exact: true,
      active: true
    },
    {
      name: "Je demande un poste de secours",
      to: '/demandeDPS',
      exact: true,
      active: true
    },
  ]
};

export const structureNavBar = {
  label: 'Espace client',
  labelDisable: true,
  children: [
    {
      name: "Mes postes de secours",
      to: '/auth/mesDPS',
      exact: true,
      active: true
    },
    {
      name: "Mes structures",
      to: '/auth/mesStructures',
      exact: true,
      active: true
    },
    {
      name: "Mon compte",
      to: '/auth/monCompte',
      exact: true,
      active: true
    },
  ]
};

export const recrutementNavBar = {
  label: "Je m'engage",
  labelDisable: true,
  children: [
    {
      name: "Recrutement",
      to: '/recrutement',
      exact: true,
      active: true
    },
  ]
};

export default [
  accueilNavBar,
  dpsNavBar,
  structureNavBar,
  recrutementNavBar,
];
